import { AppState } from 'Store'

const getCities = (state: AppState) => state.orders_design.city.items
const getRequestParams = (state: AppState) => state.orders_design.city.params

export const citiesMqSelectors = {
	getCities,
	getRequestParams,
}
